module.exports = __webpack_public_path__ + "images/SUSO-brush-group-shape.png";